/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { STATUS, editActuacion } from '../expedienteSlice';
import { subeDocumento, borraDocumento } from './documentoAPI';
import DocLink from './DocLink';
import { removeFile, updateFile, ensureInstanceInitialized } from './documentoSlice';


export default function DocumentoEditable({actuacionIndex, documentIndex}) {
    const dispatch = useDispatch();
    const { expediente, status } = useSelector((state) => state.expediente);
    let documentos;
    const isForNewActuacion = actuacionIndex === 'new';
    if (isForNewActuacion) {
        const filesState = useSelector((state) => state.documento.files);
        const instance = filesState['new'] || { files: [] };
        documentos = instance.files;
    } else {
        const actuacion = expediente.actuaciones[actuacionIndex];
        documentos = actuacion.documento_actuacion || [];
    }
    const documento = documentos[documentIndex];
    const [ loadingStatus, setLoadingStatus ] = useState('no file');
    const [documentStatus, setDocumentStatus] = useState(''); // 'changing' / 'changed' / ''

    // Ensure the instance is initialized in Redux
    useEffect(() => {
        dispatch(ensureInstanceInitialized({ which: actuacionIndex }));
    }, [dispatch, actuacionIndex]);

    useEffect(() => {
        if (status === STATUS.SAVED) {
            setDocumentStatus('');
        }
    }, [status]);

    function prepareNewFile(){
        setDocumentStatus('changing');
    }

    function cancelNewFile(){
        setDocumentStatus('');
    }

    async function deleteFile(filePath) {
        if (!filePath) {
            return true;
        }
        
        try {
            const response = await borraDocumento(filePath);
            if (response.ok) {
                return true;
            } else {
                const e = await response.text();
                throw new Error(e);
            }
                
        } catch (error) {
            return false;
        }
    }
        
    async function uploadFile(ref) {
        if (!ref) {
            return;
        }
        setLoadingStatus('uploading');
        
        // Delete old file from S3 if exists
        if (documento) {
            const deleted = await deleteFile(documento);
            if (!deleted) {
                console.warn('No se pudo eliminar el documento anterior, pero se continuará con la subida del nuevo archivo.');
            }
        }
        
        const formData = new FormData();
        formData.append('documento', ref);

        try {
            const response = await subeDocumento(formData);
            if (response.ok) {
                setLoadingStatus('success');
                setDocumentStatus('changed');
                
                const filename = await response.text();
                const convertedFilename = filename.replace('\\', '/');
                
                // Update the specific document in the array
                const newDocs = [...documentos];
                newDocs[documentIndex] = 'documentos/'+convertedFilename;
                if (isForNewActuacion) {
                    dispatch(updateFile({ which: actuacionIndex, index: documentIndex, file: 'documentos/'+convertedFilename }));
                } else {
                    dispatch(editActuacion({
                        index: actuacionIndex,
                        name: 'documento_actuacion',
                        value: newDocs
                    }));
                }
                
            } else {
                const e = await response.text();
                throw new Error(e);
            }
        } catch (error) {
            setLoadingStatus('error: ' + error);
            alert(`Ha sucedido un error: ${error}`);
        }
    }
    
    async function deleteDocument() {
        // Delete file from S3
        if (documento) {
            await deleteFile(documento);
        }
        // Remove from array
        const newDocs = documentos.filter((_, i) => i !== documentIndex);
        if (isForNewActuacion) {
            dispatch(removeFile({ which: actuacionIndex, index: documentIndex }));
        } else {
            dispatch(editActuacion({
                index: actuacionIndex,
                name: 'documento_actuacion',
                value: newDocs.length > 0 ? newDocs : null
            }));
        }
    }

    async function onClickHandler(e) {
        e.preventDefault();
        let input;
        const elementId = e.target.id.split('-')[0];
        switch (elementId) {
        case 'cambiar':
            prepareNewFile();
            break;
        case 'subir':
            input = document.getElementById(`documento_actuacion-${actuacionIndex}-${documentIndex}`);
            if (input.files){
                await uploadFile(input.files[0]);
            }
            break;
        case 'cancelar':
            cancelNewFile();
            break;
        case 'eliminar':
            if (window.confirm('¿Estás seguro de que quieres eliminar este documento?')) {
                await deleteDocument();
            }
            break;
        default:
            break;
        }
    } 

    function DocStatus ({status}) {
        if (status === 'success') {
            return '';
        } else if (status === 'error') {
            return <div className='docstatus'>❌ No se pudo cargar el documento.</div>;
        } else if (status === 'uploading'){
            return <div className='docstatus'>⏳ Cargando documento...</div>;
        } else {
            return '';
        }
    }

    if (documentStatus === 'changing') {
        return (
            <div className='docform'>
                <div>
                    <input type="file" id={`documento_actuacion-${actuacionIndex}-${documentIndex}`} name="documento_actuacion"/>
                </div>
                <div>
                    <button id={`subir-${actuacionIndex}-${documentIndex}`} onClick={onClickHandler}>Subir documento</button>
                    <button id={`cancelar-${actuacionIndex}-${documentIndex}`} onClick={onClickHandler}>Cancelar</button>
                </div>
                <DocStatus status={loadingStatus} />
            </div>
        );
    } else {
        return (
            <div className='docform'>
                <div>
                    <DocLink documento={documento} />
                    { documento && documento.split('/')[0] !== 'informe'
                        ? <>
                            <button id={`cambiar-${actuacionIndex}-${documentIndex}`} onClick={onClickHandler}>Cambiar</button>
                            <button id={`eliminar-${actuacionIndex}-${documentIndex}`} onClick={onClickHandler}>Eliminar</button>
                        </>
                        : ''
                    }
                </div>
            </div>
        );
    }
}